import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import GlobalContext from "../../framework/GlobalContext";

const DiscountProgramContext = createContext();

export const DiscountProgramContextProvider = ({ children }) => {
  const {
    currentComponent,
    autocompleteOpen,
    focusLastRow,
    setFocusLastRow,
    showSpotlight,
  } = useContext(GlobalContext);
  const [addClicked, setAddClicked] = useState(false);
  const discountProgramGridRef = useRef();
  const discountProgramRef = useRef();
  const discountProgramStartDateRef = useRef();
  const discountProgramEndDateRef = useRef();
  const categoryOptionRef = useRef();
  const saveDiscountRef = useRef();
  const addClickedRef = useRef();
  const default_focus = discountProgramGridRef;

  const listener = useCallback((event) => {
    const key = event.key?.toLowerCase();
    const ctrlKey = event.ctrlKey;
    if (ctrlKey && key === "s") {
      saveDiscountRef.current.click();
      return;
    }
    if (key === "+") {
      addClickedRef.current.click();
      return;
    }
  }, []);

  useEffect(() => {
    if (!currentComponent || currentComponent === "default_focus") {
      setTimeout(() => {
        default_focus.current?.focus();
      }, 100);
      return;
    } else if (currentComponent === "grid_discount_program") {
      if (
        discountProgramGridRef?.current?.api?.getSelectedNodes()?.length === 0
      ) {
        discountProgramGridRef?.current?.focus(focusLastRow);
        setTimeout(() => setFocusLastRow(true), 100);
      } else {
        discountProgramGridRef?.current?.focus(false);
      }
      return;
    }
  }, [currentComponent, default_focus, focusLastRow, setFocusLastRow]);

  useEffect(() => {
    if (!autocompleteOpen && !showSpotlight)
      document.addEventListener("keyup", listener, false);
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [autocompleteOpen, listener, showSpotlight]);

  return (
    <DiscountProgramContext.Provider
      value={{
        discountProgramGridRef,
        discountProgramRef,
        discountProgramStartDateRef,
        discountProgramEndDateRef,
        categoryOptionRef,
        addClicked,
        setAddClicked,
        saveDiscountRef,
        addClickedRef,
      }}
    >
      {children}
    </DiscountProgramContext.Provider>
  );
};
export default DiscountProgramContext;
